import { render, staticRenderFns } from "./EditRecordingDialog.vue?vue&type=template&id=8f5a9dc2&scoped=true"
import script from "./EditRecordingDialog.vue?vue&type=script&lang=js"
export * from "./EditRecordingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5a9dc2",
  null
  
)

export default component.exports